import {
  Divider,
  Stack,
  Text,
  Container,
  Box,
  HStack,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Flex,
  Badge,
  List,
  ListItem,
  ListIcon,
  Button,
  ButtonGroup,
  Center,
  // eslint-disable-next-line
  Image,
  useColorMode,
} from "@chakra-ui/react";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { Fade } from "react-reveal";
import { useState } from "react";

// Assuming skillsData is imported or defined in the same file
import skillsData from "./SkillsData"; // Adjust the path based on your project structure

export default function Skills({ color }) {
  const options = ["Programming", "AI/ML", "Certifications", "Software"]; // Example categories for filtering
  const [selected, setSelected] = useState(options[0]);
  const { colorMode } = useColorMode(); // Chakra's hook to get the current color mode

  const handleSelected = (value) => {
    setSelected(value);
  };

  return (
    <>
      <Container maxW={"3xl"} id="skills">
        <Stack
          as={Box}
          textAlign={"center"}
          spacing={{ base: 8, md: 14 }}
          pb={{ base: 20, md: 36 }}
        >
          <Stack align="center" direction="row" px={4}>
            <HStack mx={4}>
              <Text color={`${color}.400`} fontWeight={800}>
                04
              </Text>
              <Text fontWeight={800}>Skills & Expertise</Text>
            </HStack>
            <Divider orientation="horizontal" />
          </Stack>

          <Center px={4}>
            <ButtonGroup
              variant="outline"
              spacing={4}
              direction={{ base: "column", md: "row" }} // Stack in column on small screens and row on medium and above
              width="100%" // Ensure it does not exceed the width of the parent container
              display="flex" // Use flexbox layout
              flexWrap="wrap" // Allow the buttons to wrap on small screens
            >
              {options.map((option) => (
                <Button
                  key={option}
                  colorScheme={selected === option ? `${color}` : "gray"}
                  onClick={() => handleSelected(option)}
                  width={{ base: "100%", md: "auto" }} // Full width on small screens, auto width on larger screens
                >
                  {option}
                </Button>
              ))}
            </ButtonGroup>
          </Center>

          <Stack px={4} spacing={4}>
            {skillsData
              .filter((skill) => skill.tags.includes(selected)) // Filter skills by selected category
              .map((skill) => (
                <Fade bottom key={skill.name}>
                  <Card
                    size="sm"
                    p={4}
                    shadow="md"
                    bg={colorMode === "light" ? "gray.50" : "gray.700"} // Conditional background color based on color mode
                  >
                    <CardHeader>
                      <Flex justifyContent="space-between">
                        <HStack>
                          {/* <Image src={skill.image} h={50} alt={skill.name} /> */}
                          <Box px={2} align="left">
                            <Text
                              fontWeight={600}
                              color={colorMode === "light" ? "black" : "white"} // Text color adjustment for dark mode
                            >
                              {skill.name}
                            </Text>
                            <Text
                              color={
                                colorMode === "light" ? "black" : "gray.200"
                              } // Subtext color adjustment for dark mode
                            >
                              {skill.level}
                            </Text>
                          </Box>
                        </HStack>
                        <Text
                          px={2}
                          fontWeight={300}
                          color={colorMode === "light" ? "black" : "gray.300"} // Year experience text color
                        >
                          {skill.yearsExperience}
                        </Text>
                      </Flex>
                    </CardHeader>
                    <CardBody>
                      <Flex>
                        <List align="left" spacing={3}>
                          {skill.items.map((item, index) => (
                            <ListItem
                              key={index}
                              color={
                                colorMode === "light" ? "black" : "gray.200"
                              } // Item text color for dark mode
                            >
                              <ListIcon
                                boxSize={6}
                                as={ChevronRightIcon}
                                color={`${color}.500`}
                              />
                              {item}
                            </ListItem>
                          ))}
                        </List>
                      </Flex>
                    </CardBody>
                    <CardFooter>
                      <HStack spacing={2}>
                        {skill.badges.map((badge) => (
                          <Badge
                            key={badge.name}
                            colorScheme={badge.colorScheme || "gray"}
                          >
                            {badge.name}
                          </Badge>
                        ))}
                      </HStack>
                    </CardFooter>
                  </Card>
                </Fade>
              ))}
          </Stack>
        </Stack>
      </Container>
    </>
  );
}
